import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { environment } from '../environments/environment';

const msalConfig = {
  auth: {
    clientId: environment.msal.clientId,
    authority: `https://login.microsoftonline.com/${environment.msal.tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/login'
  },
  cache: {
    cacheLocation: environment.production ? BrowserCacheLocation.SessionStorage : BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
    secureCookies: environment.production ? true : false
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {},
      logLevel: LogLevel.Warning
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0
  }
};

export const apiScopes = {
  scopes: [environment.msal.apiScope]
};

export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: [...apiScopes.scopes]
  },
  loginFailedRoute: '/login'
};

const apiBaseUrl = environment.apiUrl.replace(/\/api\/?$/, '');
const protectedResourceMap = new Map([
  [`${apiBaseUrl}/api/*`, apiScopes.scopes]
]);

export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap
};

export function MSALInstanceFactory() {
  return new PublicClientApplication(msalConfig);
}

export const groupIds = {
  adminGroupId: environment.msal.adminGroupId,
  pmGroupId: environment.msal.pmGroupId,
  financeGroupId: environment.msal.financeGroupId,
  softwareGroupId: environment.msal.softwareGroupId,
  pcGroupId: environment.msal.pcGroupId,
  accountingGroupId: environment.msal.accountingGroupId,
  marketingGroupId: environment.msal.marketingGroupId,
  salesGroupId: environment.msal.salesGroupId,
  itGroupId: environment.msal.itGroupId,
  lndGroupId: environment.msal.lndGroupId,
  operationsGroupId: environment.msal.operationsGroupId,
  supportGroupId: environment.msal.supportGroupId
};
